<template>
  <div>
    <list-template
        :current-page="page"
        :is-check-input-box="false"
        :loading="loading"
        :search-config='searchConfig'
        :table-config="tableConfig"
        :table-data="tableData"
        :total="total"
        @onAdd="$router.push('./add')"
        @onBatchImport="()=>{dialogVisible=true}"
        @onChangePage="handleCurrentChange"
        @onExportData="exportData"
        @onHandle="handleClick"
        @onSearch="onSearch"
        @onReset="onReset"
    >
    </list-template>
    <Dialog :visible.sync="dialogVisible" title="批量导入" size="small" :showFooter="false" :closeOnClickModal="false">
      <LineWrapper>
        <LineItem label="下载模板">
          <el-button size="small" icon="el-icon-download" @click="handleDownFile">点此下载</el-button>
        </LineItem>
        <LineItem label="上传文件">
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="handleSelectFile">点击上传</el-button>
        </LineItem>
      </LineWrapper>
    </Dialog>
  </div>
</template>
<script>
import { tableListMixin } from '@/utils/mixins'
import Dialog from '@/components/common/Dialog'
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import { handleChooseFile, setConfigOption } from '@/utils'
import { fileDownload, getAllGrade, getActualSchool, get_recruit_dict } from '@/api'

export default {
  _config: {"route": {"path": "list", "meta": {"title": "列表", "keepAlive": true}}},
  components: {Dialog,LineWrapper,LineItem},
  mixins: [tableListMixin],
  data() {
    return {
      optionData: [],
      searchConfig: [
        { prop: 'student_name', placeholder: '搜索学生姓名' },
        { prop: 'school_id', placeholder: '筛选报名校区', options: [], tag: 'select' },
        { prop: 'grade_id', placeholder: '筛选入学年级', options: [], tag: 'select' },
        { prop: 'student_type', placeholder: '筛选学生类型', options: [], tag: 'select', change: (val, search) => {
          if (search.business_line) search.business_line = ''
          let list = []
          if (val === 2) {
            list = this.optionData.filter(item => [2,5].includes(item.value))
          } else {
            list = this.optionData.filter(item => [1,3,4].includes(item.value))
          }
          setConfigOption({ list: this.searchConfig , data: list, key: 'business_line' })
        }},
        { prop: 'business_line', placeholder: '筛选所属业务线', options: [], tag: 'select' },
        { prop: 'approve_status', placeholder: '筛选审批状态', options: [], tag: 'select' },
        { prop: 'fill_in', placeholder: '筛选家长是否填写信息', options: [], tag: 'select' }
      ],
      tableConfig: [
        { prop: 'student_name', label: '学生姓名' },
        { prop: 'student_type', label: '学生类型' },
        { prop: 'business_line', label: '所属业务线' },
        { prop: 'school_name', label: '报名校区' },
        { prop: 'grade_name', label: '入学年级' },
        { prop: 'creator', label: '录入人' },
        {
          prop: 'approve_status', label: '审批状态', render: (row) => {
            return `<div style="color: ${row['approve_status'] === '待审批' ? '#F09D12' : row['approve_status'] === '已通过' ? '#23C343' : '#EA0000'}">${row['approve_status']}</div>`
          }
        },
        { prop: 'fill_in', label: '家长是否填写信息' },
        { prop: 'handle', label: '操作', width: '120rem', handle: true }
      ],
      dialogVisible: false,
    }
  },
  created() {
    this.getData()
    this.getConfig()
  },
  methods: {
    getConfig() {
      getActualSchool().then(res => {
        setConfigOption({ list: this.searchConfig , data: res, key: 'school_id' })
      })
      getAllGrade().then(res => {
        setConfigOption({ list: this.searchConfig , data: res, key: 'grade_id' })
      })
      get_recruit_dict().then(res => {
        setConfigOption({ list: this.searchConfig , data: res.student_type, key: 'student_type' })
        setConfigOption({ list: this.searchConfig , data: res.business_line, key: 'business_line' })
        setConfigOption({ list: this.searchConfig , data: res.approve_status, key: 'approve_status' })
        setConfigOption({ list: this.searchConfig , data: res.fill_in, key: 'fill_in' })
        this.optionData = res.business_line
      })
    },
    onBeforeReset() {
      const list = JSON.parse(JSON.stringify(this.optionData))
      setConfigOption({ list: this.searchConfig , data: list, key: 'business_line' })
    },
    getData() {
      this.getDataApi('/zhaosheng/api/recruit-v2/offline-fresh/list')
    },
    handleClick(row) {
      this.$router.push(`./detail?id=${row.id}`)
    },
    exportData() {
      fileDownload('/zhaosheng/api/recruit-v2/offline-fresh/export-v2', {...this.search}, { name: '招生补录' })
    },
    handleSelectFile() {
      handleChooseFile({
        api: '/zhaosheng/api/recruit-v2/offline-fresh/import',
        show: true,
        html: true,
        onSuccess: () => {
          this.dialogVisible = false
          this.$message.success({ message: '文件上传成功', duration: 5000 })
          this.getData()
        }
      })
    },
    handleDownFile() {
      const config = { name: '招生补录模板', type: 'xlsx' }
      // const api = `${process.env.VUE_APP_URL_OSS}finance/template.xlsx`
      const api = '/zhaosheng/api/recruit-v2/offline-fresh/download-template'
      fileDownload(api, {}, config).then(() => {
        this.dialogVisible = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
